export const DATA_TESTID_ACTIONS_EXPORT_DATA = 'builder-applet-settings-export-data';
